import api from './api'

export default {
  async getAll() {
    const { data } = await api.get('/admin/employment-types')
    return data
  },

  async getById(id) {
    const { data } = await api.get(`/admin/employment-types/${id}`)
    return data
  },

  async create(employmentTypeData) {
    const { data } = await api.post('/admin/employment-types', employmentTypeData)
    return data
  },

  async update(id, employmentTypeData) {
    const { data } = await api.put(`/admin/employment-types/${id}`, employmentTypeData)
    return data
  },

  async delete(id) {
    const { data } = await api.delete(`/admin/employment-types/${id}`)
    return data
  }
}

